module.exports = __webpack_public_path__ + "static/media/po-lub-3.6a025630.png";